import { env } from '@/config/env'
import { apiRoutes } from '@/config/routes'
import { VaultsSdk } from '@vaultsfyi/sdk'

export function getDefiSdk() {
  const apiKey = env ? env.VAULTS_API_KEY : ''
  const apiBaseUrl = typeof window === 'undefined' ? env.VAULTS_API_URL : apiRoutes.apiProxy

  return new VaultsSdk({ apiKey }, { apiBaseUrl })
}
